// /src/data/books/Cryptonomics/cap2.js
const CRYPTONOMICS_CAP2 ={
  "title": "Capítulo 1 — Los primeros días del Bitcoin: la chispa de una revolución",
  "sections": [
    {
      "heading": "La crisis que encendió la mecha",
      "text": "Cuando el mundo aún se tambaleaba tras la crisis financiera de 2008, un mensaje comenzó a circular en foros de desarrolladores y criptógrafos. No provenía de una empresa, ni de una universidad, ni de un grupo político. Venía firmado por un nombre desconocido: Satoshi Nakamoto. Nadie sabía quién era, ni de qué país provenía. Pero su propuesta —una moneda digital descentralizada— estaba a punto de cambiar el curso de la historia económica moderna."
    },
    {
      "heading": "Bitcoin: una propuesta disruptiva",
      "text": "En esos años, la confianza en los bancos se había desplomado. Los gobiernos inyectaban dinero para rescatar a las mismas instituciones que habían provocado el colapso financiero. Y en ese ambiente de desconfianza, un documento técnico de apenas nueve páginas apareció como un manifiesto silencioso: “Bitcoin: A Peer-to-Peer Electronic Cash System”."
    },
    {
      "heading": "La red nace desde cero",
      "text": "El sistema no dependía de intermediarios, sino de una red distribuida en la que cada participante podía verificar y registrar las transacciones. No había bancos, ni autoridades centrales, solo matemáticas, criptografía y consenso colectivo. Los primeros en sumarse descargaron el software, ejecutaron el código y comenzaron a minar. Así nació el bloque génesis."
    },
    {
      "heading": "El mensaje oculto",
      "text": "Ese bloque inicial contenía una línea que marcó un antes y un después: “The Times 03/Jan/2009 Chancellor on brink of second bailout for banks.” Extraída del periódico británico, esa frase funcionó como prueba de tiempo y como crítica directa al sistema financiero tradicional."
    },
    {
      "heading": "Una idea que se convirtió en red",
      "text": "Durante ese primer año, el valor del Bitcoin era casi simbólico. No existían intercambios, ni cotizaciones, ni mercados. Era un proyecto entre entusiastas de la criptografía. Pero quienes entendieron su potencial vieron más que una moneda: vieron una revolución. Bitcoin no era solo código. Era una declaración de independencia económica."
    },
    {
      "heading": "El legado del bloque génesis",
      "text": "Con cada nuevo bloque, se consolidaba un principio inédito: la inmutabilidad. Una vez que la información es validada y agregada a la cadena, no puede ser modificada sin romper el resto. Así nació una red global y descentralizada que, sin líderes visibles ni entidades de control, dio origen a un nuevo paradigma: confiar en el código, no en las instituciones."
    }
  ],
  "image": {
    "src": "https://raw.githubusercontent.com/AppsDevsLeon/ImagesBooks/main/imagesFundamentosBlockchain/genesis_block_esquema.png",
    "alt": "Bloque Génesis de Bitcoin",
    "caption": "El bloque génesis marcó el nacimiento del Bitcoin en enero de 2009, con un mensaje oculto como crítica al sistema bancario tradicional."
  }
}


export default CRYPTONOMICS_CAP2;

